import { appConfig } from '@config';
import { HTTP_VSUITE_MAINTENANCE } from '@constants/http-codes';
import axiosInstance from '@helpers/api/axiosInstance';

export const requestWrapper =
  agent =>
  (config = {}) => ({
    get: (path, payload) =>
      agent
        .get(`${appConfig.apiUrl}/${path}`, { params: payload, ...config })
        .catch(failErrorResponse),
    post: (path, payload) =>
      agent.post(`${appConfig.apiUrl}/${path}`, payload, config).catch(failErrorResponse),
    put: (path, payload) =>
      agent.put(`${appConfig.apiUrl}/${path}`, payload, config).catch(failErrorResponse),
    patch: (path, payload) =>
      agent.patch(`${appConfig.apiUrl}/${path}`, payload, config).catch(failErrorResponse),
    delete: (path, payload) =>
      agent
        .delete(`${appConfig.apiUrl}/${path}`, { data: { ...payload }, ...config })
        .catch(failErrorResponse),
  });

/**
 * Reload the window to push active users out of the app when we are in maintenance mode.
 * We count the number of reloads to prevent an infinite loop
 */
const redirectForMaintenance = () => {
  const counter = window.history?.state?.maintenanceRefresh || 1;

  if (counter <= 3) {
    window.history.pushState({ maintenanceRefresh: counter + 1 }, window.location.pathname);
    window.location.reload();
  }
};

const failErrorResponse = ({ response }) => {
  const { status } = response;

  if (status === HTTP_VSUITE_MAINTENANCE) {
    redirectForMaintenance();
    return Promise.reject(new Error(`${appConfig.vsuite.name} is down for maintenance`));
  }

  return response;
};

export default requestWrapper(axiosInstance);
